module.exports = __webpack_public_path__ + "static/media/comment-edit.410d8f9b.svg";